<template>
    <BaseCard v-if="tonalThemeEnabled" v-bind="$attrs" padding="sm">
        <div class="border-b border-border body-small pb-4 mb-4 text-ink-muted"><i class="bi bi-people-fill mr-2" aria-hidden="true"></i>{{ attendees.length }} Attendees</div>
        <div class="max-h-50 overflow-auto flex flex-col gap-2">
            <div v-for="attendee in attendeesList" :key="attendee" class="text-ink-muted flex gap-2 items-center">
                <BaseAvatar theme="neutral" size="sm" :initials="getFirstLastInitials(attendee)" translate="no" aria-hidden="true" />
                <span class="body-small">{{ attendee }}</span>
            </div>
        </div>
    </BaseCard>
    <div v-else v-bind="$attrs" class="px-4 py-5 rounded-lg bg-white border border-valence-grey-300">
        <div class="border-b body-small pb-4 mb-4 text-[#595959]"><i class="bi bi-people-fill mr-2" aria-hidden="true"></i>{{ attendees.length }} Attendees</div>
        <div class="max-h-50 overflow-auto flex flex-col gap-2">
            <div v-for="attendee in attendeesList" :key="attendee" class="text-[#595959] flex gap-2 items-center">
                <div
                    class="bg-[#BCE7F4] border border-valence-grey-300 min-w-6 max-w-6 min-h-6 max-h-6 flex items-center justify-center text-center rounded-full details font-normal"
                    translate="no"
                    aria-hidden="true">
                    {{ getFirstLastInitials(attendee) }}
                </div>
                <span class="body-small font-normal">{{ attendee }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseAvatar from "~vue/components/BaseAvatar.vue";
import BaseCard from "~vue/components/BaseCard.vue";
import { getFirstLastInitials } from "~vue/utils/stringUtils";
import { tonalThemeEnabled } from "~vue/utils/theme";
import { computed } from "vue";

defineOptions({ inheritAttrs: false });

const { attendees } = defineProps<{ attendees: Array<{ name: string; email: string }> }>();
// TODO: Remove the legacy calendar branch once the tonal theme becomes the default.

const attendeesList = computed(() => attendees.map(({ name, email }) => name || email));
</script>
